import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { IPlayerNote } from '@/components/chat/_domain/models/player-notes-model';
import { User } from '@/app-modules/store/modules/user';
import { format } from 'date-fns';
import { UserChatStatus } from '@/components/chat/_domain/modules/user-chat-status-service/user-chat-status-service-interface';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IPlayerNotesService } from '@/components/chat/_domain/modules/player-notes-service';

enum PlayerNoteSavingStatus {
  NotSet = 0,
  Saving,
  Saved
}

@Component({
  name: 'PlayerNoteDetailsComponent'
})
export default class PlayerNoteDetailsComponent extends TombolaBaseComponent {
  @Prop() private playerUsername: string;
  @Prop() private playerNote: IPlayerNote;
  @Prop() private showNoteDetails: boolean;
  private savingStatus: PlayerNoteSavingStatus = PlayerNoteSavingStatus.NotSet;
  private isLoading: boolean = false;

  private get playerNoteDetail(): IPlayerNote {
    return this.playerNote;
  }

  private set playerNoteDetail(value: IPlayerNote) {
    this.$emit('update:playerNoteInDetail', value);
  }

  private get showingNoteDetails(): boolean {
    return this.showNoteDetails;
  }
  private set showingNoteDetails(value: boolean) {
    this.$emit('update:showNoteDetails', value);
  }

  private get isSaving(): boolean {
    return this.savingStatus !== PlayerNoteSavingStatus.NotSet;
  }

  private get savingCssClasses(): { [key: string]: boolean } {
    return {
      'fa-spin fa-circle-o-notch': this.savingStatus === PlayerNoteSavingStatus.Saving,
      'fa-check': this.savingStatus === PlayerNoteSavingStatus.Saved
    };
  }

  private async saveNote() {
    await this.$validator.validateAll();
    if (!this.$validator.errors.any()) {
      this.setSavingStatus(PlayerNoteSavingStatus.Saving);
      try {
        await this.playerNotesService.updatePlayerNote(this.playerNoteDetail.NoteId, this.playerNoteDetail.Value, this.playerUsername);
      } finally {
        this.setSavingStatus(PlayerNoteSavingStatus.Saved);
        this.returnToPlayerNotesSummary();
      }
    }
  }

  private setSavingStatus(status: PlayerNoteSavingStatus): void {
    const timeout = status === PlayerNoteSavingStatus.Saving ? 0 : 400;
    setTimeout(() => {
      this.savingStatus = status;
      if (status === PlayerNoteSavingStatus.Saved) {
        this.setSavingStatus(PlayerNoteSavingStatus.NotSet);
      }
    }, timeout);
  }

  private returnToPlayerNotesSummary(): void {
    this.playerNoteDetail = null;
    this.showingNoteDetails = false;
  }

  private formattedTimeStamp(value: string): string {
    return format(value, 'YYYY-MM-DD HH:mm:ss');
  }

  private get hasPermissionToEditNote(): boolean {
    return this.isLoggedInUserShiftLeader() || this.isLoggedInUserTeamLeader();
  }

  private isLoggedInUserTeamLeader(): boolean {
    const user = this.$tombolaStore.Get(User);
    return user.userChatStatus === UserChatStatus.TeamLeader;
  }

  private isLoggedInUserShiftLeader(): boolean {
    const user = this.$tombolaStore.Get(User);
    return user.userChatStatus === UserChatStatus.ShiftLeader;
  }

  private get playerNotesService(): IPlayerNotesService{
    return this.$container.get(SERVICE_IDENTIFIERS.IPlayerNotesService);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/player-notes/_components/player-note-details/player-note-details.component.ts